import React, { useState } from "react";
import Select, { components } from "react-select";
import Search from "../../components/Header/Search/Search";
import SalaryComponentList from "./SalaryComponentList";
import userRoles from "../../config/userRoles";
import { DatePicker } from "antd";
import dayjs from "dayjs";
const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <span className="ico-down text-blue-600"></span>
    </components.DropdownIndicator>
  );
};

const SalaryComponentTable = ({
  salaryComponents,
  isLoading,
  error,
  fetchFilteredData,
  onEdit,
}) => {


  const roleLabels = {
    [userRoles.TENANTADMIN]: "Admin",
    [userRoles.HR]: "HR",
    [userRoles.FINANCEADMIN]: "Finance",
  };

  const allowedRoles = [
    userRoles.TENANTADMIN,
    userRoles.HR,
    userRoles.FINANCEADMIN,
  ];

  const roleOptions = [
    { value: 0, label: "All" },
    ...allowedRoles.map((role) => ({
      value: role,
      label: roleLabels[role] || "Unknown",
    })),
  ];

  const [filters, setFilters] = useState({
    date: null,
    added_by_role_id: 0,
    added_by: "",
    filter: "",
  });



  const handleDateChange = (date, dateString) => {
    if (!date) {
      const updated = { ...filters, date: null };
      setFilters(updated);
      sendFiltersToBackend(updated);
      return;
    }

    const formatted = date.format("YYYY-MM-DD");
    const updated = { ...filters, date: formatted };
    setFilters(updated);
    sendFiltersToBackend(updated);
  };

  const handleRoleChange = (selectedOption) => {
    const roleId = selectedOption?.value ?? 0;
    const updated = { ...filters, added_by_role_id: roleId };
    setFilters(updated);
    sendFiltersToBackend(updated);
  };
const handleSearchChange = (searchValue) => {
  const updated = { ...filters, filter: searchValue };
  setFilters(updated);
  sendFiltersToBackend(updated);
};

  const sendFiltersToBackend = (updatedFilters) => {
    if (typeof fetchFilteredData === "function") {
      fetchFilteredData(updatedFilters);
    } else {
      console.warn("fetchFilteredData is not defined");
    }
  };

 const handleClearFilters = () => {
  const clearedFilters = {
    date: null,
    added_by_role_id: 0,
    filter: "",
  };
  setFilters(clearedFilters);
  sendFiltersToBackend(clearedFilters);
};


  if (isLoading) return <p>Loading...</p>;
  if (error) return <p>Error loading data.</p>;

  return (
    <div className="w-full">
      <div className="flex items-center justify-between px-10 pb-4 mt-8">
        <div className="flex gap-3 items-center">
          <DatePicker
            placeholder="Added Date"
            onChange={handleDateChange}
            format="YYYY-MM-DD"
            value={filters.date ? dayjs(filters.date) : null}
          />

          <Select
            options={roleOptions}
            components={{ DropdownIndicator }}
            className="custom-select-container text-gray-500"
            value={roleOptions.find((opt) => opt.value === filters.added_by_role_id)}
            onChange={handleRoleChange}
          />
               {(filters.date || filters.added_by_role_id !== 0 || filters.filter) && (
          <button
            className="text-blue-600 cursor-pointer"
            onClick={handleClearFilters}
          >
            Clear filters
          </button>
        )}
        </div>

   

        <div className="flex items-center">
      <Search mx="0" value={filters.filter} onChange={handleSearchChange} />

{/* Will implemented  soon  */}
          {/* <a href="" className="btn btn--border text-[14px]">
            <span>
              <i className="ico-download mr-1"></i>
            </span>
            Download
          </a> */}
        </div>
      </div>

      <SalaryComponentList
        salarycomponentData={salaryComponents}
        onEdit={onEdit}
      />
    </div>
  );
};

export default SalaryComponentTable;
